export default __webpack_public_path__ + "static/media/dcLOGO.e0a08ce0.png";